/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BasicInformation/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import HumanId from './HumanId/index'
import Locations from './Locations/index'
import ProfileImage from './ProfileImage/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function BasicInformation({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/BasicInformation"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let patientBookingValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'booking',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let patientPersonValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'person',
})
let aggregateData = fromAggregate.basicPatientInformation(patientPersonValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<div
  data-testid="BasicInformation.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-1ABX4J': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-2-1ABX4J': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--g-3-1ABX4J': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal}`}
>
<ProfileImage
  viewPath={`${viewPath}/ProfileImage`}
/>
<div
  data-testid="BasicInformation.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<button
  data-testid="BasicInformation.Horizontal:1"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--c-4-1ABX4J': patientBookingValueData ? "pointer" : "normal"}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="patient.person"
 aggregate="/Data/aggregate.js basicPatientInformation"
 text={aggregateData}
 weight="medium"
 size="normal"
/>
</button>
<div
  data-testid="BasicInformation.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-3-1ABX4J': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal2}`}
>
<Locations
  viewPath={`${viewPath}/Locations`}
/>
<div
  data-testid="BasicInformation.Horizontal:3"
  data-view-path={viewPath}
 style={{'--w-5-1ABX4J': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--h-6-1ABX4J': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-7-1ABX4J': dtColorsNeutral300}}
 className={`views-block ${styles.Horizontal3}`}
/>
<HumanId
  viewPath={`${viewPath}/HumanId`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}